export const getVisibilityIconProps = (trip: any) => {
  const className = "Wyjazd_buttonIcon" + (trip.isVisible ? "" : "--hidden");
  if (trip.isVisible)
    return {
      icon: "visibility",
      className
    };

  return {
    icon: "visibility_off",
    className
  };
};

export const getDetailsIconProps = (isExpanded: boolean) => {
  const className = "Wyjazd_buttonIcon";
  if (isExpanded)
    return {
      icon: "expand_less",
      className
    };

  return {
    icon: "expand_more",
    className
  };
};
